import { LicenceTableDto } from './licenceTableDto';

export class LicenceWizardDto {
  addLicences: LicenceTableDto[] = [];
  editLicences: LicenceTableDto[] = [];
}
